import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';
import type { SeriesActions } from '../../core/types/series-actions-template.js';

export function getLegendInteractionProps(
  isPinned: boolean,
  isLoading: boolean,
  hasNameAccessor: boolean,
  legendActions: SeriesActions<LegendItem>,
  onHover: (hoveredSeries?: LegendItem) => void,
  onClick: (visibleSlices: LegendItem[]) => void,
) {
  if (isPinned || isLoading) {
    return { interactionsDisabled: true };
  }

  if (hasNameAccessor) {
    return {
      onHover: onHover,
      interactionsDisabled: true,
    };
  }

  return {
    onSeriesAction: legendActions,
    onHover: onHover,
    onClick: onClick,
    interactionsDisabled: false,
  };
}
